var ve = {
  CustomEvent: "ce",
  Pr: "p",
  Kl: "pc",
  oc: "ca",
  Ra: "i",
  qs: "ie",
  T: "cci",
  W: "ccic",
  _: "ccc",
  L: "ccd",
  ph: "ss",
  nh: "se",
  Je: "si",
  Re: "sc",
  He: "sbc",
  Pe: "sfe",
  ro: "iec",
  xl: "lr",
  Ul: "uae",
  U: "ci",
  F: "cc",
  Gl: "lcaa",
  Bl: "lcar",
  En: "inc",
  An: "add",
  Un: "rem",
  Sn: "set",
  Jl: "sgu"
},
    De = {
  Fr: "feed_displayed",
  ac: "content_cards_displayed"
};
export { ve as EventTypes, De as InternalEventTypes };